var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back-to-top-container",class:{
    invisible: _vm.hide,
    'back-to-top-coverage-list-cart-summary': _vm.coverageListCart && _vm.coverageListCart.length > 0,
  }},[_c('button',{staticClass:"back-to-top-button",attrs:{"data-testid":"scroll-to-top-button"},on:{"click":_vm.scrollToTop}},[_c('Icon',{staticClass:"back-to-top-arrow",attrs:{"name":"arrow-up","size":"lg"}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }